import {AppDispatch} from "../store";
import {authSlice} from "../reducers/AuthSlice";
import {authApi} from "../../api/authApi";
import {LoginDto} from "../../api/dto/login.dto";
import {toast} from "react-toastify";
import {EnumAuthenticationMode} from "../../components/Authentication/Authentication";
import {appSlice} from "../reducers/AppSlice";
import {UXToast} from "../../enums/UXText/UXToast";
import {UpdateProfileDto} from "../../api/dto/profile/update-profile.dto";
import {getTextByLanguage} from "../../enums/utils/getTextByLanguage";

export const loginThunk = ({email, password, language}: LoginDto) => async (dispatch: AppDispatch) => {


    try {
        dispatch(authSlice.actions.setIsLoading(true))
        const result = await authApi.login({email, password})
        if (result.data.user.isActivated) {
            localStorage.setItem('token', result.data.accessToken)
            dispatch(authSlice.actions.setIsAuth(true))
            dispatch(authSlice.actions.setProfile(result.data.user))
        }


        if (Number(result.data.user.isActivated) === 0) {
            if (language) {
                const toastText = getTextByLanguage(UXToast.login.verified, language)
                toast.info(toastText)
            }

        }



    } catch (error) {
        // @ts-ignore
        const message = error.response?.data?.message
        console.error(error)
        console.log(message)
        if (Array.isArray(message)) {
            message.forEach((errorMessage:string) => toast.error(errorMessage, {
                hideProgressBar: true
            }))
        } else {
            toast.error(message, {
                hideProgressBar: true
            })
        }


    } finally {
        dispatch(authSlice.actions.setIsLoading(false))
    }
}

interface registrationThunkProps {
    registerData: LoginDto,
    setAuthenticationMode: (props: EnumAuthenticationMode) => void
}

export const registrationThunk = ({
                                      registerData,
                                      setAuthenticationMode
                                  }: registrationThunkProps) => async (dispatch: AppDispatch) => {
    dispatch(authSlice.actions.setIsLoading(true))
    try {
        const result = await authApi.registration({email: registerData.email, password: registerData.password})
        localStorage.setItem('token', result.data.accessToken)
        // dispatch(authSlice.actions.setIsAuth(true))
        dispatch(authSlice.actions.setProfile(result.data.user))
        setAuthenticationMode(EnumAuthenticationMode.registrationSuccess)
        dispatch(authSlice.actions.setIsLoading(false))
    } catch (error) {
        // @ts-ignore
        const message = error.response?.data?.message
        console.error(error)
        toast.error(message, {
            hideProgressBar: true
        })
        dispatch(authSlice.actions.setIsLoading(false))
    }
}

export const checkAuth = () => async (dispatch: AppDispatch) => {

    try {
        const result = await authApi.checkAuth()
        if (result.data.user.isActivated) {
            dispatch(authSlice.actions.setIsAuth(true))
            dispatch(authSlice.actions.setProfile(result.data.user))
            localStorage.setItem('token', result.data.accessToken)
        }
        dispatch(appSlice.actions.setLoading(false))
        return true

    } catch (error) {
        dispatch(authSlice.actions.setIsAuth(false))
        dispatch(appSlice.actions.setLoading(false))
        return true
    }
}

export const updateProfileThunk = (dto: UpdateProfileDto) => async (dispatch: AppDispatch) => {
    try {
        const result = await authApi.updateProfile(dto)
        dispatch(authSlice.actions.setProfile(result.data.user))
        localStorage.setItem('token', result.data.accessToken)
    } catch (error) {
        toast.error('Ошибка при обновлении пользователя')
        console.log(error)
    }
}